/*
  Shoes Egy — homepage size bar.

  Liquid on the homepage cannot see filter counts: `collection.filters` is only
  populated in a collection or search context. So the rail is rendered by
  shoes-egy-size-rail.liquid against the all-products collection and pulled in
  here through the Section Rendering API.

  The bar ships hidden and is only revealed once real chips arrive. If the fetch
  fails, or every size is out of stock, it stays hidden rather than showing an
  empty band — a size bar with nothing in it is worse than no size bar.
*/
(() => {
  const mount = (bar) => {
    const rail = bar.querySelector('[data-size-rail]');
    if (!rail || !bar.dataset.src) return;

    fetch(bar.dataset.src)
      .then((res) => (res.ok ? res.text() : Promise.reject(res.status)))
      .then((html) => {
        const source = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector('[data-size-rail-source]');
        if (!source || !source.querySelector('.shoes-size-chip')) return;

        rail.replaceChildren(...source.childNodes);
        bar.hidden = false;
      })
      .catch(() => {
        /* leave the bar hidden — the page reads fine without it */
      });
  };

  const start = () => document.querySelectorAll('[data-size-bar]').forEach(mount);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
